// extracted by mini-css-extract-plugin
export default {"Card":"index__Card--gbGoD","card":"index__Card--gbGoD","CardHorizontal":"index__CardHorizontal--5FMVJ","cardHorizontal":"index__CardHorizontal--5FMVJ"};